import { GoogleDownasaurIcon } from './GoogleDownasaurIcon';

/**
 * author: Simran
 * id D9285386-5BA5-423A-8F3B-435E7A57363A
 * name google-downasaur
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/google-downasaur.svg
 * tags
 * - Animal 
 * - Gaming / RPG 
 */
export const TRexIcon = GoogleDownasaurIcon;
export default TRexIcon